/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const RectangleVertical = [
  "svg",
  defaultAttributes,
  [["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2" }]]
];

export { RectangleVertical as default };
//# sourceMappingURL=rectangle-vertical.js.map
